import { render, staticRenderFns } from "./FormResetPassword.modal.vue?vue&type=template&id=cf7cb36e&scoped=true&"
import script from "./FormResetPassword.modal.vue?vue&type=script&lang=ts&"
export * from "./FormResetPassword.modal.vue?vue&type=script&lang=ts&"
import style0 from "./FormResetPassword.modal.vue?vue&type=style&index=0&id=cf7cb36e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7cb36e",
  null
  
)

export default component.exports